import React, { memo } from 'react';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';

const RemoveFileIcon = ({ deleteFile }) => (
    <span className="remove-action-container">
        <i
            className="icon-trash text-danger"
            onClick={deleteFile}
            onKeyDown={deleteFile}
            role="button"
            tabIndex="0"
        />
    </span>
);

RemoveFileIcon.propTypes = {
    deleteFile: PropTypes.func.isRequired,
};

export default compose(
    memo,
)(RemoveFileIcon);
